<template>
  <div class="legal">
    <!-- Hero -->
    <section class="legal__hero container">
      <p class="eyebrow reveal">Vos données · RGPD</p>
      <h1 class="legal__title reveal" style="animation-delay:.05s">
        Politique de<br><span class="hl">confidentialité</span>
      </h1>
      <p class="legal__lead reveal" style="animation-delay:.12s">
        On collecte le strict minimum pour faire tourner le site, et rien pour
        vous pister. Voici, en clair, ce qu'on garde et pourquoi.
      </p>
      <p class="legal__updated reveal" style="animation-delay:.16s">
        Dernière mise à jour&nbsp;: 10&nbsp;juillet&nbsp;2026
      </p>
    </section>

    <section class="container prose">
      <article class="block reveal">
        <h2>Qui est responsable de vos données&nbsp;?</h2>
        <p>
          Le responsable du traitement des données personnelles collectées sur
          <strong>labanane.net</strong> est l'éditeur du site, <strong>Yann&nbsp;F.</strong>,
          que vous pouvez contacter à tout moment à
          <a class="mail" href="mailto:contact@labanane.net">contact@labanane.net</a>.
          La Banane est un site personnel et <strong>non commercial</strong>&nbsp;:
          aucune donnée n'est vendue, louée ou exploitée à des fins publicitaires.
        </p>
      </article>

      <article class="block reveal">
        <h2>Quelles données on collecte</h2>
        <p>On ne collecte que ce dont le service a réellement besoin&nbsp;:</p>
        <ul class="lst">
          <li>
            <strong>Compte&nbsp;:</strong> votre adresse e-mail et le nom
            d'affichage que vous choisissez. Si vous vous connectez via Google
            (SSO), on reçoit de Google votre e-mail et votre nom — jamais votre
            mot de passe.
          </li>
          <li>
            <strong>Mot de passe&nbsp;:</strong> si vous créez un compte par
            e-mail, votre mot de passe est stocké <strong>chiffré</strong> (jamais
            en clair) et n'est lisible par personne, pas même nous.
          </li>
          <li>
            <strong>Contributions&nbsp;:</strong> vos votes, vos commentaires et
            les blagues que vous proposez, rattachés à votre compte.
          </li>
          <li>
            <strong>Journaux techniques&nbsp;:</strong> comme tout site web, notre
            hébergeur enregistre automatiquement certaines données de connexion
            (adresse IP, date/heure, type de navigateur) dans les logs serveur, à
            des fins de sécurité et de bon fonctionnement.
          </li>
        </ul>
        <p>
          On <strong>n'utilise aucun outil d'analyse d'audience, de tracking
          publicitaire ou de profilage</strong> (pas de Google Analytics, pas de
          régie pub, pas de pixels tiers).
        </p>
      </article>

      <article class="block reveal">
        <h2>Pourquoi on les traite (finalités &amp; base légale)</h2>
        <ul class="lst">
          <li>
            <strong>Fournir le service&nbsp;:</strong> créer et gérer votre compte,
            enregistrer vos votes, commentaires et propositions.
            <em>Base légale&nbsp;: exécution du service que vous demandez
            (art.&nbsp;6.1.b RGPD).</em>
          </li>
          <li>
            <strong>Modération &amp; qualité&nbsp;:</strong> vérifier et modérer
            les contenus soumis pour garder le site convivial et légal.
            <em>Base légale&nbsp;: intérêt légitime (art.&nbsp;6.1.f).</em>
          </li>
          <li>
            <strong>Sécurité&nbsp;:</strong> prévenir le spam, les abus et les
            intrusions via les journaux techniques.
            <em>Base légale&nbsp;: intérêt légitime (art.&nbsp;6.1.f).</em>
          </li>
        </ul>
      </article>

      <article class="block reveal">
        <h2>Combien de temps on les garde</h2>
        <ul class="lst">
          <li>
            <strong>Données de compte &amp; contributions&nbsp;:</strong> tant que
            votre compte existe. Si vous supprimez votre compte (ou nous le
            demandez), elles sont effacées.
          </li>
          <li>
            <strong>Journaux techniques&nbsp;:</strong> conservés de façon limitée
            (généralement quelques mois au maximum) puis supprimés ou anonymisés.
          </li>
        </ul>
        <p>
          Une fois votre compte supprimé, vos contributions peuvent être
          <strong>anonymisées</strong> plutôt que supprimées si elles font partie
          d'un fil de discussion utile aux autres — dissociées de votre identité.
        </p>
      </article>

      <article class="block reveal">
        <h2>À qui on les confie (sous-traitants)</h2>
        <p>
          On ne partage vos données qu'avec les prestataires techniques
          strictement nécessaires au fonctionnement du site&nbsp;:
        </p>
        <ul class="lst">
          <li>
            <strong>Amazon Web Services (AWS)</strong> — hébergement du site et de
            la base de données, dans la région <strong>eu-west-3 (Paris,
            France)</strong>, donc au sein de l'Union européenne.
          </li>
          <li>
            <strong>Google</strong> — uniquement si vous choisissez la connexion
            «&nbsp;Se connecter avec Google&nbsp;» (SSO), pour authentifier votre
            identité.
          </li>
        </ul>
        <p>
          Ces prestataires agissent comme sous-traitants et n'utilisent pas vos
          données pour leur propre compte dans le cadre de notre service.
        </p>
      </article>

      <article class="block reveal">
        <h2>Transferts hors Union européenne</h2>
        <p>
          Vos données sont hébergées <strong>en France (région AWS de Paris)</strong>.
          On ne procède à <strong>aucun transfert de vos données hors de l'UE à
          des fins marketing ou commerciales.</strong> Le seul échange avec un
          acteur non-européen concerne l'authentification Google (SSO), et
          uniquement si vous l'utilisez&nbsp;; Google encadre ces échanges par ses
          propres garanties contractuelles.
        </p>
      </article>

      <div class="cookies reveal">
        <h2>🍪 Cookies &amp; stockage local</h2>
        <p>
          La Banane <strong>n'utilise que des cookies et du stockage techniques</strong>,
          indispensables au fonctionnement du site. Concrètement&nbsp;:
        </p>
        <ul class="lst lst--dark">
          <li>
            un <strong>cookie de session</strong> (Django) pour vous garder connecté
            le temps de votre visite&nbsp;;
          </li>
          <li>
            un <strong>jeton d'authentification (JWT)</strong> stocké dans le
            <em>localStorage</em> de votre navigateur, pour vous reconnaître d'une
            visite à l'autre sans redemander votre mot de passe.
          </li>
        </ul>
        <p class="cookies__note">
          Ces éléments sont <strong>strictement nécessaires</strong> et exemptés de
          consentement&nbsp;: il n'y a <strong>ni traceur publicitaire, ni cookie
          de mesure d'audience, ni cookie tiers</strong>. C'est pour ça que vous ne
          voyez pas de bandeau «&nbsp;cookies&nbsp;» — on n'a rien à vous faire
          accepter. Vider le stockage de votre navigateur vous déconnectera
          simplement.
        </p>
      </div>

      <article class="block reveal">
        <h2>Vos droits</h2>
        <p>
          Conformément au RGPD, vous disposez à tout moment des droits suivants sur
          vos données&nbsp;:
        </p>
        <ul class="lst">
          <li><strong>Accès&nbsp;:</strong> savoir quelles données on détient sur vous.</li>
          <li><strong>Rectification&nbsp;:</strong> corriger une information inexacte (nom, e-mail…).</li>
          <li><strong>Effacement&nbsp;:</strong> demander la suppression de votre compte et de vos données.</li>
          <li><strong>Portabilité&nbsp;:</strong> récupérer vos données dans un format lisible.</li>
          <li><strong>Opposition &amp; limitation&nbsp;:</strong> vous opposer à un traitement fondé sur notre intérêt légitime, ou en demander la limitation.</li>
        </ul>
        <p>
          Pour exercer l'un de ces droits, il suffit d'écrire à
          <a class="mail" href="mailto:contact@labanane.net">contact@labanane.net</a>.
          On vous répond dans les meilleurs délais (et au plus tard sous un mois,
          comme le prévoit le RGPD).
        </p>
      </article>

      <article class="block reveal">
        <h2>En cas de litige</h2>
        <p>
          Si vous estimez que vos droits ne sont pas respectés, vous pouvez nous
          contacter en premier lieu — on fera de notre mieux pour trouver une
          solution. Vous avez aussi le droit d'introduire une réclamation auprès de
          la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des
          Libertés),
          <a class="mail" href="https://www.cnil.fr" target="_blank" rel="noopener">www.cnil.fr</a>,
          3 place de Fontenoy, TSA 80715, 75334 Paris Cedex 07.
        </p>
      </article>

      <p class="seealso reveal">
        Voir aussi&nbsp;:
        <router-link to="/mentions-legales">Mentions légales</router-link> ·
        <router-link to="/cgu">Conditions d'utilisation</router-link>
      </p>
    </section>

    <section class="container legal__cta">
      <BananaButton to="/" size="lg" variant="dark">🍌 Retour aux blagues</BananaButton>
    </section>
  </div>
</template>

<script>
import BananaButton from '@/components/ui/BananaButton.vue'

export default {
  name: 'PageConfidentialite',
  components: { BananaButton },
}
</script>

<style scoped>
.legal__hero { text-align: center; padding: 56px 20px 24px; }
.legal__title { font-size: clamp(2.4rem, 7vw, 4.4rem); }
.hl { color: var(--banana-700); }
.legal__lead {
  font-family: var(--font-accent);
  font-style: italic;
  font-size: clamp(1.15rem, 2.6vw, 1.5rem);
  color: var(--ink-700);
  max-width: 600px;
  margin: 10px auto 0;
}
.legal__updated {
  font-size: 0.85rem;
  color: var(--ink-500);
  margin: 14px auto 0;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.prose { display: flex; flex-direction: column; gap: 26px; padding: 20px 20px 10px; }

.block h2 { font-size: clamp(1.35rem, 3.4vw, 1.95rem); margin-bottom: 0.5em; }
.block p { font-size: 1.08rem; line-height: 1.7; color: var(--ink-800); margin: 0 0 0.9em; }
.block p:last-child { margin-bottom: 0; }
.block em { font-family: var(--font-accent); font-style: italic; color: var(--ink-700); }
.block strong { color: var(--ink-900); }

.lst { list-style: none; margin: 0.4em 0 0.9em; padding: 0; display: flex; flex-direction: column; gap: 10px; }
.lst li {
  position: relative;
  padding: 0 0 0 26px;
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--ink-800);
}
.lst li::before {
  content: "🍌";
  position: absolute;
  left: 0; top: 1px;
  font-size: 0.95rem;
}
.lst strong { color: var(--ink-900); }
.lst em { font-family: var(--font-accent); font-style: italic; color: var(--ink-700); }

.mail {
  color: var(--banana-800);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 2px;
  word-break: break-word;
}
.mail:hover { color: var(--banana-700); }

/* Cookies — dark highlight card */
.cookies {
  background: var(--choco);
  color: var(--banana-100);
  border-radius: var(--r-lg);
  border: var(--border-w) solid var(--border-c);
  box-shadow: var(--shadow-lg);
  padding: 32px 32px 30px;
  margin: 8px 0;
}
.cookies h2 { color: var(--banana-400); font-size: clamp(1.4rem, 3.6vw, 2rem); }
.cookies p { font-size: 1.06rem; line-height: 1.7; opacity: 0.92; margin: 0 0 0.9em; }
.cookies strong { color: var(--banana-300); }
.cookies em { font-family: var(--font-accent); font-style: italic; color: var(--banana-200); }
.lst--dark li { color: var(--banana-100); opacity: 0.92; }
.lst--dark li::before { content: "•"; color: var(--banana-400); font-size: 1.2rem; top: -2px; }
.lst--dark strong { color: var(--banana-300); }
.cookies__note { margin-bottom: 0 !important; opacity: 0.85; }

.seealso {
  text-align: center;
  font-size: 0.95rem;
  color: var(--ink-500);
  margin: 6px 0 0;
}
.seealso a { color: var(--banana-800); font-weight: 600; text-decoration: underline; text-underline-offset: 3px; }
.seealso a:hover { color: var(--banana-700); }

.legal__cta { text-align: center; padding: 26px 20px 60px; }

@media (max-width: 620px) {
  .legal__hero { padding: 40px 4px 20px; }
  .prose { padding-left: 4px; padding-right: 4px; }
  .cookies { padding: 26px 22px; }
}
</style>
